<template lang="pug">
v-card(style="border-bottom-left-radius: 0;border-bottom-right-radius: 0;")

  //- BARRA de titulo
  v-app-bar(:elevation="0")
    v-toolbar-title
      v-card-title.pl-1.pb-4 Filtro

    v-spacer

    v-btn(
      icon
      @click="clearFilter()"
    )
      v-icon mdi-broom

    v-btn(
      icon
      @click="$emit('input',!value)"
    )
      v-icon mdi-close

  //- FORMULARIO de filtragem
  v-form(
    ref="form"
    @submit.prevent="search"
  )

    v-card-text.pb-0
      v-row.mb-2
        v-col(cols="12")
          v-btn(
            color='primary'
            block
            small
            @click="search"
          )
            v-icon(left) mdi-refresh
            | Aplicar

    div.pt-2(style="height:calc(100vh - 160px - 46px); overflow-y: auto; overflow-x: hidden;")

      v-card-text.pb-1
        widget(
          ref="widget"
          v-for="field in fields"
          v-model="field.value"
          :key="field.name"
          :field="field"
          :hidden="isSearchField(field)"
          outlined
          dense
          @action-performed="search"
        )
</template>

<script>
import Vue from 'vue'
import GridFilterBtn from './GridFilterBtn'
import Widget from '@/components/widgets/Widget'
import { computeAll } from '@/helpers/conditions'

export default {
  components: {
    GridFilterBtn,
    Widget,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,
  },

  computed: {
    fields() {
      const items = this.filter?.fields || []
      items.map(field => Vue.set(field, 'value', field.value))
      computeAll(items, this.context)
      return items.filter(item => !item.hidden)
    },

    context () {
      const items = this.filter?.fields || []
      const context = {}
      items.map(field => context[field.name] = field.value)
      return context
    },
  },

  methods: {
    clearFilter (reset) {
      const { form, widget: widgets } = this.$refs

      form.resetValidation()
      widgets.forEach(widget => {
        reset ? widget.field?.reset() : widget.field?.clear()
      })
    },

    isSearchField (field) {
      return field.rel?.includes('Search')
    },

    search () {
      if (this.$refs.form.validate()) {
        this.$emit('refresh')
      }
    },

    // updateQueryString() {
    //   const queryString = this.encodeFilter(this.fields)
    //   this.$router.replace({ query: { q: queryString } })
    // },

    // encodeFilter (fields) {
    //   const filter = {}
    //   fields
    //     .filter(field => field?.value !== undefined)
    //     .forEach(field => filter[field.name] = field.value)
    //   const json = JSON.stringify(filter)
    //   const text = Buffer.from(json)?.toString('base64')
    //   const query = encodeURI(text)
    //   return encodeURI(query)
    // },
  }
}
</script>